import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "../../context/AxiosInstance";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const ConfirmDeleteModal = ({ show, handleClose, conge, token, refreshData }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async () => {
    if (!conge || !conge.id_conge) {
      MySwal.fire("Erreur", "Aucun congé sélectionné", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.patch(
        `conges/${conge.id_conge}/etat`,
        { is_active: false },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      MySwal.fire("Congé Supprimé 🗑", res.data?.message || "", "success");
      refreshData();
      handleClose();
    } catch (err) {
      const msg =
        err.response?.data?.detail?.message ||
        err.response?.data?.detail ||
        "Échec de la suppression";
      MySwal.fire("Erreur ❌", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Confirmer la suppression</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Êtes-vous sûr de vouloir supprimer ce congé ?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Annuler
        </Button>
        <Button variant="danger" onClick={handleConfirmDelete} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Supprimer"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
